import { Keyboard } from '@capacitor/keyboard';
import { isPlatform } from '@ionic/react';

export async function hideKeyboard(): Promise<void> {
  if (isPlatform('hybrid')) {
    try {
      await Keyboard.hide?.();
    } catch {
      // ignore errors from native Keyboard.hide
    }
  }

  if (typeof document !== 'undefined' && document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
}
